import useLenis from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { About } from "@/components/site/About";
import { Fleet } from "@/components/site/Fleet";
import { TrainingHub } from "@/components/site/TrainingHub";
import { Services } from "@/components/site/Services";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="App grain relative bg-[#E9EEF5]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <About />
        <Fleet />
        <TrainingHub />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
